import Berg from '../../assets/imagens/avatares/profissionais/GutembergReboucas.png'
import Button from '../../components/ui/Button'

import { useAuth } from '../../context/AuthContext';
import {useState} from 'react'

import {motion} from 'motion/react'

import './Chat.css'
export default function Chat({seguir}){

    const [enviarMensagem, setEnviarMensagem] = useState(false)

    const {user} = useAuth();

    const somNotificacao = () =>{
        const audio = new Audio('/sounds/sendMessage.mp3')
        audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))
    }

    const somSeguir = () =>{
        const audio = new Audio('/sounds/cyber.mp3')
        audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))
    }

    const handleEnviarMensagem = () =>{
        setEnviarMensagem(true)

        setTimeout(()=>{
            somNotificacao()
        }, 600)
    }

    const handleSeguir = () =>{
        somSeguir()

        setTimeout(()=>{
            seguir()
        },1000)
    }

    return(
        <div className="chat">
            
            <motion.div 
                initial={{opacity:0, scale:0}}
                animate={{opacity:1, scale:1}}
                transition={{
                    duration:0.4,
                    scale:{type:"spring", visualDuration:0.4, bounce:0.5}
                }}
                onAnimationStart={somNotificacao}
                 className='mensagem avatar'
                >
                <img src={Berg} />
                <div>
                    <h3 >Gutemberg Rebouças</h3  >
                    <p>
                        Olá, Tudo bem?
                        Estou com um problema no Wi-Fi do meu notebook. Ele não está conectando à rede da empresa, mesmo tentando 
                        conectar manualmente. Conseguem me dar uma força?
                    </p>
                </div>
            </motion.div>

           {enviarMensagem && 
            <motion.div 
                initial={{opacity:0, scale:0}}
                animate={{opacity:1, scale:1}}
                transition={{
                    duration:0.4,
                    scale:{type:"spring", visualDuration:0.4, bounce:0.5}
                }}
            
                className="mensagem resposta"
                >
                <h3>
                    {user.name}
                </h3>
                <p>
                    Claro, Berg!
                    Pode vir até a sala da TI, por gentileza? Vamos dar uma olhada nisso juntos!
                </p>

            </motion.div>

           }

            <Button 
                text={!enviarMensagem ? "Responder" : "Seguir"}
                className='btnAmarelo'
                onClick={!enviarMensagem ? ()=>handleEnviarMensagem() : ()=>handleSeguir()}
            />
        </div>
    )
}